import React from "react"
import moment from "moment";
import { getHyreferralCampaignsPropertiesBreakdown } from "relay/campaigns"
import { getCreateEventPath } from "constants/path"
import { compare } from "content/utils/commonParsing"
import Loading from "storybookComponents/Loader"
import StyledTable from 'components/TableComponent';
import EmptyView from "../Components/NoPropView"
import EmptyViewCampaign from "images/EmptyViewCampaign.svg"
import CampaignFilterBar from "./allCampaignFilterBar"
import {
  // getDataForAllCampaigns,
  getAllCampaignsRows,
  getColumnsForAllCampaigns
} from "../common"

const AllCampaigns = ({ subMenu, subOrgDetails, propertiesOfOrg, classes, history, handleSelectCampaign }) => {
  const [monthRange, setMonthRange] = React.useState({ startAt: moment().startOf("month"), endAt: moment().endOf("month"), label: "This Month" })
  const [selectedProperties, setSelectedProperties] = React.useState([]);
  const [rows, setRows] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const handleClickCampaign = (item) => {
    handleSelectCampaign({
      ...item,
      status: ['all'],
    })
  }


  React.useEffect(() => {
    getPropertyBreakDown([], monthRange.startAt, monthRange.endAt)
  }, [1])


  const getPropertyBreakDown = async (propertyIds, startAt, endAt) => {
    setLoading(true);
    try {
      let response = await getHyreferralCampaignsPropertiesBreakdown(subOrgDetails.org.id, propertyIds, [], startAt, endAt);
      if (response.hyreferralCampaignsPropertiesBreakdown) {
        setData(response.hyreferralCampaignsPropertiesBreakdown)
        setRows(getAllCampaignsRows(response.hyreferralCampaignsPropertiesBreakdown, classes, handleClickCampaign))
        setLoading(false)
      }
    } catch (err) {
      console.log("Err", err)
    }
  }

  const handleSort = (field, order) => {
    let sortedData = data.slice().sort((a, b) => compare(a[field], b[field], !order))
    setRows(getAllCampaignsRows(sortedData, classes, handleClickCampaign));
  }
  const handleChangeProperty = (selected) => {
    setSelectedProperties(selected)
    getPropertyBreakDown(selected, monthRange.startAt, monthRange.endAt)
  }

  // const handleMonthRange = (time) => {
  //   setMonthRange(time);
  //   getPropertyBreakDown(selectedProperties, time.startAt, time.endAt)
  // }

  const onClickNewCampaign = () => {
    history.push(getCreateEventPath());
  };

  const handleFilterProperty = (f, key) => {
    if (f) {
      let filteredData = data.slice().filter(item => {
        if (item[key]) {
          return item[key].toLowerCase().includes(f.toLowerCase())
        }
      })
      setRows(getAllCampaignsRows(filteredData, classes, handleClickCampaign))
    } else {
      setRows(getAllCampaignsRows(data, classes, handleClickCampaign))
    }
  }
  return (
    <div>
      <CampaignFilterBar
        propertiesOfOrg={propertiesOfOrg}
        selectedProperties={selectedProperties}
        //monthRange={monthRange}
        handleChangeProperty={handleChangeProperty}
        //handleMonthRange={handleMonthRange}
        classes={classes}
      //subOrgDetails={subOrgDetails}
      />
      <div className={classes.bottomViewCampaignAll}>
        {
          loading ? <Loading /> : (data.length == 0) ? <EmptyView handleButtonClick={onClickNewCampaign} message="No campaign is created yet. Create a new campaign now." image={EmptyViewCampaign} showButton={true} /> :
            <div>
              <div className={classes.allCampaignHeader}>Select a campaign you wish to see the By Campaign report of</div>
              <StyledTable
                columns={getColumnsForAllCampaigns(classes, handleFilterProperty)}
                rows={rows}
                sortHandler={handleSort}
                className={classes.tableContainerCampaignRoot}
                defaultSortBy="propertyName"
                showFilter={true}
              />
            </div>
        }
      </div>
    </div>
  )
}

export default AllCampaigns